/// <reference path="appConfig.d.ts" />
'use strict';

window.appConfig = window.appConfig || {};
const angular:angular.IAngularStatic =  require('angular');

import { getInjectableName} from 'ng-metadata/core';
import {MappingTablesCache} from '../mappingTablesCache/mappingTablesCache.service';
import {getInstitutionCode, getAutocompleteUrl, getBackendSystem} from './appConfigForward';

    let module = angular.module('appConfig');

    module.constant('limit', '14')
        .constant('loginEndpoint', loginEndpoint())
        .constant('imagesBarLimit', '25')
        .constant('itemTabs', getItemTabs)
        .constant('imagesBarFillers', getImagesBarFilter)
        .constant('primoDateFormat', 'yyyy-MM-dd') // TODO old one? dont use it?
        .constant('displayDateFormat', 'MM/dd/yyyy')
        .constant('accountListBulkSize', '10');

/*---------- rest URLs---------------------------------*/
    let restBaseURLSuprima= '/primaws/rest';
    let restBaseURLsSuprima={
            resourceRecommenderUrl: restBaseURLSuprima + '/pub/resourceRecommender',
            deliveryBaseURL: restBaseURLSuprima+'/priv/delivery/representationInfo',
            officeFileURL: restBaseURLSuprima+'/priv/delivery/officeFile',
            updateStatistics:restBaseURLSuprima+'/priv/delivery/updateStatistics',
            referenceEntryUrl: restBaseURLSuprima + '/priv/externalServices/referenceEntry', 
            myAccountBaseURL: restBaseURLSuprima+'/priv/myaccount',
            userSettingsBaseURL: restBaseURLSuprima+'/priv/usersettings',
            favoritesBaseURL: restBaseURLSuprima+'/priv/favorites',
            bestOfferURL: restBaseURLSuprima +'/pub/ngrs/bestoffer/physical',
            ngrsCreateBorrowingRequestURL: restBaseURLSuprima +'/pub/ngrs/bestoffer/borrowingrequest',
            tagsBaseURL: restBaseURLSuprima+'/priv/tags',
            tagsSearchBaseURL: restBaseURLSuprima+'/priv/tags/searchTags?tagTerm=',
            pnxBaseURL: restBaseURLSuprima +'/pub/pnxs',
            deliveryURL: restBaseURLSuprima +'/pub/delivery',
            getFacetsBaseURL: restBaseURLSuprima +'/pub/facets',
            pushToBaseURL: restBaseURLSuprima +'/pub/pushto',
            actionsBaseURL: restBaseURLSuprima+'/pub/actions',
            opacBaseUrl: restBaseURLSuprima+'/priv/ILSServices/titleServices',
            openUrl: restBaseURLSuprima+'/pub/openurl',
            ILSServicesBaseURL: restBaseURLSuprima+'/priv/ILSServices',
            prepareElectorincRTA: restBaseURLSuprima+'/pub/edelivery',
            calculatePhysicalServiceId: restBaseURLSuprima+'/pub/getPhysicalService',
            translationsUrl: restBaseURLSuprima + '/pub/translations',
            bxUrl: restBaseURLSuprima + '/pub/bx/recId',
            thumbUrl: restBaseURLSuprima + '/v1/syndetics-thumb',
            browse: restBaseURLSuprima +'/pub/browse',
            saveSearchURL : restBaseURLSuprima + '/priv/savedSearches',
            snippetURL: restBaseURLSuprima + '/pub/snippets',
            savedQueries: restBaseURLSuprima + '/v1/savedSearches',
            citationTrails: restBaseURLSuprima + '/pub/citation-trails',
            citationTrailsSeedsInfo: restBaseURLSuprima + '/pub/citation-trails/seeds-info',
            timesCited: restBaseURLSuprima + '/pub/timesCited',
            sourceRecord: restBaseURLSuprima + '/pub/sourceRecord',
            scopeListBaseURL: restBaseURLSuprima+'/v1/configuration',
            calculatePcDelivery : restBaseURLSuprima + '/pub/pcDelivery',
            journalsAutocomplete : restBaseURLSuprima + '/pub/journals/autocomplete',
            loginJwtCache: restBaseURLSuprima + '/pub/loginJwtCache',
            rss: restBaseURLSuprima + '/priv/savedSearches/addRss',
            memberPnx: restBaseURLSuprima + '/priv/nz/pnx',
            showPnxInXmlUrl: restBaseURLSuprima + '/pub/pnxs/xml',
            dbCategoriesBaseURL: restBaseURLSuprima + '/pub/restDlf/categories',
            directLink: restBaseURLSuprima + '/pub/directLink',
            relateditems: restBaseURLSuprima+ '/v1/relatedItems',
            orgListEsploroUrl: restBaseURLSuprima + '/pub/restDlf/orgList'
       };

    let restBaseURLPrimoExplore= '/primo_library/libweb/webservices/rest';
    let restBaseURLsPrimoExplore={
        resourceRecommenderUrl: restBaseURLPrimoExplore + '/v1/resourceRecommender',
        deliveryBaseURL: restBaseURLPrimoExplore+'/v1/delivery/representationInfo',
        updateStatistics:restBaseURLPrimoExplore+'/priv/delivery/updateStatistics',
        officeFileURL: restBaseURLPrimoExplore+'/priv/delivery/officeFile',
        referenceEntryUrl: restBaseURLPrimoExplore + '/v1/externalServices/referenceEntry',
        myAccountBaseURL: restBaseURLPrimoExplore+'/v1/myaccount',
        dbCategoriesBaseURL: restBaseURLPrimoExplore+'/v1/categories',
        userSettingsBaseURL: restBaseURLPrimoExplore+'/v1/usersettings',
        favoritesBaseURL: restBaseURLPrimoExplore+'/v1/favorites',
        tagsBaseURL: restBaseURLPrimoExplore+'/v1/tags',
        tagsSearchBaseURL: restBaseURLPrimoExplore+'/v1/tags/searchTags?tagTerm=',
        pnxBaseURL: restBaseURLPrimoExplore +'/primo-explore/v1/pnxs',
        pushToBaseURL: restBaseURLPrimoExplore +'/v1/pushto',
        actionsBaseURL: restBaseURLPrimoExplore+'/v1/actions',
        opacBaseUrl: restBaseURLPrimoExplore+'/v1/ILSServices/services',
        openUrl: restBaseURLPrimoExplore+'/v1/openurl',
        ILSServicesBaseURL: restBaseURLPrimoExplore+'/v1/ILSServices',
        translationsUrl: restBaseURLPrimoExplore + '/v1/translations',
        bxUrl: restBaseURLPrimoExplore + '/v1/bx/recId',
        thumbUrl: restBaseURLPrimoExplore + '/v1/syndetics-thumb',
        browse: restBaseURLPrimoExplore + '/v1/browse',
        saveSearchURL : restBaseURLPrimoExplore + '/v1/savedSearches',
        snippetURL: restBaseURLPrimoExplore + '/v1/snippet',
        savedQueries: restBaseURLPrimoExplore + '/v1/savedSearches',
        citationTrails: restBaseURLPrimoExplore + '/v1/citation-trails',
        citationTrailsSeedsInfo: restBaseURLPrimoExplore + '/v1/citation-trails/seeds-info',
        timesCited: restBaseURLPrimoExplore + '/timesCited',
        sourceRecord: restBaseURLPrimoExplore + '/v1/sourceRecord',
        scopeListBaseURL: restBaseURLPrimoExplore+'/v1/configuration',
        journalsAutocomplete : restBaseURLPrimoExplore + '/pub/journals/autocomplete',
        loginJwtCache: restBaseURLPrimoExplore + '/v1/loginJwtCache',
        showPnxInXmlUrl: restBaseURLPrimoExplore + '/primo-explore/v1/pnxs/xml',
        rss: '/primo_library/libweb/action/../newRss',
        relateditems: restBaseURLPrimoExplore+ '/v1/relatedItems'
    };
    module.constant('restBaseURLs', getBackendSystem() === 'suprima'? restBaseURLsSuprima : restBaseURLsPrimoExplore);



    module.factory('autoCompleteConfig', AutoCompleteConfig)
        .factory('configurationService', ConfigurationService);


    function AutoCompleteConfig($stateParams, mtCacheService) {
        let inst = getInstitutionCode();
        let token = getToken();
        let url = getAutocompleteUrl();
        let isScopesEnabled = isScopesACConfigEnabled(); 

        return {
            isEnabled: isEnabled,
            url: url,
            getDefaultParams: getDefaultParams
        };

        function getDefaultParams(scope) {
            let searchScopesMap = getCurrTabScopes(scope);  
        
            let scopesContextMap= window.appConfig['scopes-context-map'];
            let context= scopesContextMap ? scopesContextMap[scope] : 'L';
            
            let scopes = ''; 
		             
          if (isScopesEnabled === 'true' && (context === 'B' || context === 'L')) { 
            var scopeRegexp = /scope:\((.*?)\)/g; 
                let match = scopeRegexp.exec(searchScopesMap); 
                while (match != null) { 
                  scopes += token + match[1].replace(/"/g, '').replace(/\s+/g, '#') + ' OR '; 
                  match = scopeRegexp.exec(searchScopesMap); 
                } 
                if (scopes.length > 4) { 
                    scopes = scopes.slice(0, -4); 
                } 
            } 
             
            if (scopes.length == 0) { 
                scopes = token; 
            } 
             
           

            /* PRM-35080
               Bug: NUI calls to AC have different context parameter for blended search then CUI calls,which returns different results
            */
            if (context === 'B') {
                 context = 'L OR C';
            }

            let defaultParams = {
                facet: 'off',
                fq:'scope:(' + scopes + ')+AND+context:('+context+')',
                rows: '6',
                wt:'json'
            };
            return defaultParams;

        }

        function getToken() {
            try {
                return mtCacheService.findByProperties(mtCacheService.tables.AUTO_COMPLETE_CONFIG, {target: inst})[0].source1;
            } catch (err) {
                return '';
            }
        }

        function isEnabled(scope) {
            return window.appConfig['primo-view']['auto-complete-enabled-map'][scope] || false;
        }
        
        function isScopesACConfigEnabled() { 
            try { 
                return mtCacheService.findByProperties(mtCacheService.tables.AUTO_COMPLETE_CONFIG, {target: inst})[0].source3 || false; 
            } catch (err) { 
                return false; 
            }  
        } 
         
        function getCurrTabScopes(scope) { 
            let cur = window.appConfig['primo-view'].scopes.filter(function(obj) { return obj['scope-id'] === scope;}); 
            if (cur && cur.length > 0) { 
                return cur[0]['locations']; 
            } 
            return ''; 
        } 
    }
    
          
		        

    AutoCompleteConfig.$inject = ['$stateParams', getInjectableName(MappingTablesCache)];

    function getItemTabs() {
        let detailsPane = {icon:'lib/material-design-icons/action/svg/production/ic_info_outline_24px.svg',
            label:'Details',
            tabContent:'details-pane'};

        let locationPane = {icon:'lib/material-design-icons/action/svg/production/ic_explore_24px.svg',
            label:'Locations',
            tabContent:'locations-pane'};

        let itemTabs = [
            detailsPane ,
            locationPane
        ];
        return itemTabs;
    }

    function getImagesBarFilter() {
        let imagesBarFillers = [{link:'custom/img/HVD/harvard1.jpg', type:'default'},
            {link:'custom/img/HVD/harvard2.jpg', type:'default'},
            {link:'custom/img/HVD/harvard3.jpg', type:'default'},
            {link:'custom/img/HVD/harvard4.jpg', type:'default'},
            {link:'custom/img/HVD/harvard5.jpg', type:'default'},
            {link:'custom/img/HVD/harvard6.jpg', type:'default'},
            {link:'custom/img/HVD/harvard7.jpg', type:'default'},
            {link:'custom/img/HVD/harvard8.jpg', type:'default'},
            {link:'custom/img/HVD/harvard9.jpg', type:'default'}];

        return imagesBarFillers;
    }










    function ConfigurationService() {
        return {
            getTab: getTab
        };

        function getTab(scope) {
            let defaultTab = 'default_tab';
            let cur = window.appConfig['primo-view'].scopes.filter(function(obj) { return obj['scope-id'] === scope;});
            if (cur && cur.length > 0) {
                return cur[0]['tab-id-for-scope-matching'] || defaultTab;
            }
            return defaultTab;
        }
   }




    function loginEndpoint() {
        return getBackendSystem() === 'suprima' ? 'primaws/suprimaLogout' : 'primo_library/libweb/primoExploreLogin';
    }






// WEBPACK FOOTER //
// ./src/main/webapp/components/appConfig/appConfig.ts